<template>
  <v-container>
    <v-card class="mx-auto my-12" max-width="374">
      <v-card-title>Recuperación de contraseña</v-card-title>
      <v-text-field
        style="margin-right: 20px; margin-left: 20px"
        v-model="contrasena"
        :type="verContrasena ? 'text' : 'password'"
        label="Contraseña Nueva"
        :append-icon="verContrasena ? 'mdi-eye' : 'mdi-eye-off'"
        required
        @keypress.enter="enfocarContrasena"
        @click:append="verContrasena = !verContrasena"
      >
      </v-text-field>
      <v-text-field
        style="margin-right: 20px; margin-left: 20px"
        v-model="contrasenaConfirmada"
        :type="verContrasena ? 'text' : 'password'"
        :append-icon="verContrasena ? 'mdi-eye' : 'mdi-eye-off'"
        label="Confirmar Contraseña Nueva"
        required
        :rules="reglaContrasena"
        ref="contrasena"
        @keypress.enter="establecerContrasena"
        @click:append="verContrasena = !verContrasena"
      >
      </v-text-field>
      <v-btn color="green" dark class="my-6 mx-5" @click="establecerContrasena">
        Guardar Contraseña
        <v-icon right dark> mdi-content-save-all </v-icon>
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
export default {
  data() {
    return {
      contrasena: "",
      contrasenaConfirmada: "",
      correo: "",
      fecha: "",
      hash: "",
      verContrasena: false,
      reglaContrasena: [
        (v) => !!v || "Correo Requerido",
        (v) => (v || "").indexOf(" ") < 0 || "No spaces are allowed",
        (v) => (v || "").length > 8 || "Se necesitan 8 caracteres minimo",
        (v) =>
          v == this.contrasena ||
          "No coincide con la contraseña introducida anteriormente",
      ],
    };
  },
  methods: {
    //Obtenemos los parametros de la url
    obtenerParametrosUrl() {
      var url = window.location.search;
      var urlParametros = new URLSearchParams(url);
      this.correo = urlParametros.get("correo");
      this.fecha = urlParametros.get("fecha");
      this.hash = urlParametros.get("clave");
      if (!this.correo || !this.fecha || !this.hash)
        this.$router.push({ path: "/" });
    },

    //Establecemos la contraseña que indica el usuario
    establecerContrasena() {
      if (
        this.contrasena !== this.contrasenaConfirmada ||
        this.contrasenaConfirmada.length < 8
      ) {
        this.$root.$dialogo.activarDialogo(
          "Fallo al restablecer contrasena",
          "Contraseñas no coincide con los criterios establecidos",
          ["OK"]
        );
      } else {
        ApiZD.establecerNuevaContrasena(
          this.correo,
          this.contrasena,
          this.fecha,
          this.hash
        ).then(() => {
          this.$root.$dialogo
            .activarDialogo(
              "Contraseña cambiada",
              "Se ha cambiado la contraseña correctamente.",
              ["Volver al inicio"]
            )
            .then((res) => {
              if (res == 0) this.$router.push({ path: "/" });
            });
        });
      }
    },
    enfocarContrasena() {
      this.$refs.contrasena.focus();
    },
  },
  created() {
    this.obtenerParametrosUrl();
  },
};
</script>

<style>
</style>